import type { StudentCase } from '@/widgets/layouts/main/students-cases/constants/cases-list';

import { Article } from '@/shared/components/article';
import { TextFade } from '@/shared/components/fade-text';
import { TextGradient } from '@/shared/components/text-gradient';

interface SpecificCaseProps {
  studentCase: StudentCase;
}

export const Main = (props: SpecificCaseProps) => {
  const { studentCase } = props;

  return (
    <Article tag="main">
      <div className="flex-col items-center py-10 sm:flex">
        <TextGradient
          className="mb-2 text-center text-4xl xs:text-5xl sm:mb-6 md:text-7xl lg:text-8xl"
          tag="h1"
          text={studentCase.name}
        />

        <TextFade
          text={studentCase.description}
          tag="p"
          className="max-w-lg text-center text-muted-foreground lg:text-lg lg:leading-7"
        />
      </div>
    </Article>
  );
};
